export default __webpack_public_path__ + "static/ab-laptop-2-mobile-235f22ec817fc52710cf65cb40f57cee.jpg";